// DetailPage.jsx
import React, { useState, useEffect } from 'react';
import '../css/GiftDetail.css';

const GiftDetail = () => {
  const [itemData, setItemData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [platform, setPlatform] = useState('web');

  useEffect(() => {
    // Detectar plataforma
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const mobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
    setIsMobile(mobile);

    if (/android/i.test(userAgent)) {
      setPlatform('android');
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      setPlatform('ios');
    } else {
      setPlatform('web');
    }

    // Extraer itemId y token de la URL
    const pathParts = window.location.pathname.split('/');
    const detailIndex = pathParts.indexOf('gift-detail');
    
    if (detailIndex !== -1 && pathParts.length > detailIndex + 2) {
      const itemId = pathParts[detailIndex + 1];
      const token = pathParts[detailIndex + 2];
      
      validateAndFetchData(itemId, token);
    } else {
      // Si no hay itemId o token, solo mostramos las opciones de descarga
      setLoading(false);
    }
  }, []);

  const validateAndFetchData = async (itemId, token) => {
    try {
      // Aquí deberías hacer la llamada real a tu API
      // Ejemplo: const response = await fetch(`/api/detail/${itemId}?token=${token}`);
      
      // Simulación de validación de token y obtención de datos
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Simulación: considera el token válido si tiene más de 10 caracteres
      if (token.length < 10) {
        throw new Error('Token inválido');
      }

      // Datos de ejemplo - reemplaza con tu llamada API real
      const data = {
        id: itemId,
        title: 'Tarjeta regalo IguanaGIFT',
        description: 'Regala una tarjeta estas navidades',
        image: 'https://www.iguanagift.com/assets/logo.png',
        price: '99.99€',
        details: [
          'No tiene caducidad',
          'Fáciles de regalar',
          'Ideal en cualquier ocasión'
        ]
      };

      setItemData(data);
      
      // Actualizar metadatos dinámicamente
      updateMetaTags(data);
      
      setLoading(false);
    } catch (err) {
      // Si hay error en la validación, simplemente no mostramos el detalle
      // pero sí mostramos las opciones de descarga
      console.error('Error validando token:', err);
      setLoading(false);
    }
  };

  const updateMetaTags = (data) => {
    // Actualizar title
    document.title = data.title;

    // Función auxiliar para actualizar/crear meta tags
    const setMetaTag = (property, content, isProperty = true) => {
      const attr = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attr}="${property}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, property);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Open Graph tags
    setMetaTag('og:title', data.title);
    setMetaTag('og:description', data.description);
    setMetaTag('og:image', data.image);
    setMetaTag('og:url', window.location.href);
    setMetaTag('og:type', 'product');

    // Twitter tags
    setMetaTag('twitter:card', 'summary_large_image', false);
    setMetaTag('twitter:title', data.title, false);
    setMetaTag('twitter:description', data.description, false);
    setMetaTag('twitter:image', data.image, false);

    // Meta description
    setMetaTag('description', data.description, false);
  };

  const handleDownload = (type) => {
    const links = {
      ios: 'https://apps.apple.com/iguanagift/id6753006906',
      android: 'https://play.google.com/store/apps/details?id=es.kaps.iguanagift',
    };
    
    if (links[type]) {
      window.open(links[type], '_blank');
    }
  };

  const DetailContent = () => (
    <div className="detail-content">
      {itemData && (
        <>
          <img 
            src={itemData.image} 
            alt={itemData.title}
            className="detail-image"
          />
          <div className="detail-body">
            <h2 className="detail-title">
              {itemData.title}
            </h2>
            <p className="detail-price">
              {itemData.price}
            </p>
            <p className="detail-description">
              {itemData.description}
            </p>
            <div className="detail-features">
              <h3 className="features-title">
                Características:
              </h3>
              <ul className="features-list">
                {itemData.details.map((detail, index) => (
                  <li key={index} className="feature-item">
                    <span className="feature-check">✓</span>
                    {detail}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </>
      )}
    </div>
  );

  const LogoContent = () => (
        <img 
            src='/assets/logo.png' 
            alt='IguanaGIFT'
            className="logo"
        />
  );

  const AppDownloadSection = () => (
    <div className="download-section">
      <h3 className="download-title">
        Descarga nuestra app
      </h3>
      <p className="download-subtitle">
        Obtén la mejor experiencia con nuestra aplicación móvil
      </p>
      
      {platform === 'web' ? (
        <div className="download-buttons-web">
          <img 
            src="/assets/app-store-badge.svg" 
            alt="Descargar en App Store"
            onClick={() => handleDownload('ios')}
            style={{ cursor: 'pointer', height: '60px' }}
            />

          <img 
            src="/assets/google-play-badge.svg" 
            alt="Descargar en Google Play"
            onClick={() => handleDownload('android')}
            style={{ cursor: 'pointer', height: '60px' }}
            />
          
          <div className="qr-section">
            <p className="qr-text">
              Escanea el código QR con tu móvil
            </p>
            <div className="qr-container">
              <div className="qr-placeholder">
                <img alt='IguanaGIFT' src='/assets/qrcode_IguanaGIFT_QR.png' />
              </div>
            </div>
          </div>
        </div>
      ) : platform === 'ios' ? (
        <img 
            src="/assets/app-store-badge.svg" 
            alt="Descargar en App Store"
            onClick={() => handleDownload('ios')}
            style={{ cursor: 'pointer', height: '60px' }}
            />
      ) : (
        <img 
            src="/assets/google-play-badge.svg" 
            alt="Descargar en Google Play"
            onClick={() => handleDownload('android')}
            style={{ cursor: 'pointer', height: '60px' }}
            />
      )}
    </div>
  );

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-content">
          <div className="loading-spinner"></div>
          <p className="loading-text">Cargando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      {!isMobile ? (
        // Vista Desktop: Simulación de móvil + App download al lado
        <div className="desktop-layout">
          {/* <div className={`desktop-grid ${!itemData ? 'desktop-grid-centered' : ''}`}> */}
          <div className={`desktop-grid`}>
            {/* Simulación de pantalla móvil - solo si hay itemData */}
            {itemData && (
              <div className="mobile-frame-container">
                <div className="mobile-frame">
                  <div className="mobile-frame-inner">
                    {/* Notch */}
                    <div className="mobile-notch-container">
                      <div className="mobile-notch"></div>
                    </div>
                    {/* Pantalla */}
                    <div className="mobile-screen">
                      <LogoContent />
                    </div>
                  </div>
                </div>
              </div>
            )} 
            {!itemData && (
                <LogoContent />
            )} 
            {/* Sección de descarga */}
            {/* <div className={itemData ? 'download-column' : 'download-column-centered'}> */}
            <div className={'download-column'}>
              <AppDownloadSection />
            </div>
          </div>
        </div>
      ) : (
        // Vista Mobile: Detail arriba (si existe), descarga abajo
        <div className="mobile-layout">
          {itemData && (
            <div className="mobile-detail-section">
              <DetailContent />
            </div>
          )}
          <div className={`mobile-download-section ${!itemData ? 'mobile-download-centered' : ''}`}>
            <div className={!itemData ? 'mobile-download-full' : ''}>
              <AppDownloadSection />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GiftDetail;